import { render, staticRenderFns } from "./index.vue?vue&type=template&id=866b301e&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TherapistSearch: require('/home/nvpa/nvpa-corporate/nuxt/components/therapist/Search.vue').default,GeneralTour: require('/home/nvpa/nvpa-corporate/nuxt/components/general/Tour.vue').default,NewsItem: require('/home/nvpa/nvpa-corporate/nuxt/components/news/Item.vue').default,ActivitiesCalendarList: require('/home/nvpa/nvpa-corporate/nuxt/components/activities/CalendarList.vue').default,GeneralPaymentPopup: require('/home/nvpa/nvpa-corporate/nuxt/components/general/PaymentPopup.vue').default,HomePopup: require('/home/nvpa/nvpa-corporate/nuxt/components/home/Popup.vue').default})
